import { FormEvent, useState } from 'react';
import { useAuth } from '../state/AuthProvider';
import { Shell } from '../ui/PwaContent';

export function LoginView() {
  const authContext = useAuth();
  const [message, setMessage] = useState<string>('');
  const [loading, setLoading] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setLoading(true);
    setMessage('');

    const form = new FormData(event.currentTarget);

    try {
      await authContext.login({
        login: String(form.get('login') ?? ''),
        password: String(form.get('password') ?? ''),
      });

      window.location.href = '/logout/';
    } catch (error) {
      setMessage(error instanceof Error ? error.message : 'Login fehlgeschlagen.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Shell title="Login" subtitle="Melde dich mit Benutzername oder E-Mail und Passwort an.">
      <form onSubmit={submit} className="grid max-w-2xl gap-4">
        <label className="grid gap-1 text-sm font-bold">
          Benutzername oder E-Mail
          <input className="wwpwa-input" name="login" autoComplete="username" required />
        </label>

        <label className="grid gap-1 text-sm font-bold">
          Passwort
          <input className="wwpwa-input" name="password" type="password" autoComplete="current-password" required />
        </label>

        <button className="wwpwa-button-primary" type="submit" disabled={loading}>
          {loading ? 'Login läuft ...' : 'Einloggen'}
        </button>
      </form>

      {message && <div className="mt-4 rounded-xl border border-red-200 bg-red-50 p-3 text-red-900">{message}</div>}

      <p className="mt-4 text-sm text-gray-600">
        Noch kein Konto? <a className="font-bold text-red-700" href="/registrieren/">Registrieren</a>
      </p>
    </Shell>
  );
}
